import {WRONG_EMAIL_NOTIFICATION, WRONG_NAME_NOTIFICATION} from 'consts/wordings';
import {getEmailErrorMessage, getProperNameErrorMessage, getUserNameErrorMessage} from 'utils/validators';
import { AccountInfoData, FormNotifications, CurrentUser } from 'types';

export const getAccountTypeStep = (
  user: CurrentUser,
  notifications: Record<string, FormNotifications>,
  onPass: (newUser: AccountInfoData | CurrentUser, id: string) => void,
) => ({
  stepName: 'Account Type',
  onPass: async (data: AccountInfoData) => {
    onPass(data, 'signUpStep1');
  },
  formProps: {
    buttonCaption: 'Continue',
    notifications: notifications,
    fields: [
      {
        type: 'notification',
        fieldName: 'signUpStep1',
      },
      {
        type: 'title',
        fieldName: 'title',
        value: 'Time to get SENDY!',
      },
      {
        type: 'description',
        fieldName: 'value',
        value: 'You have the flexibility to update your account type at a later time',
      },
      {
        type: 'reachRadioBlock',
        fieldName: 'account_type',
        value: 'individual',
        reachOptions: [
          {
            icon: '/icons/commerce/Individual.svg',
            caption: 'Individual',
            option: 'individual',
          },
          {
            icon: '/icons/commerce/Business.svg',
            caption: 'Business',
            option: 'business',
          },
        ],
      },

    ],
  },
});
